import { titleCase } from 'change-case'
import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs'
import General from './General'

export default () => {
  const currentTab = 'Dark mode'
  return (
    <div className="container">
      <Breadcrumbs
        paths={[
          { title: 'Settings', to: '/settings' },
          { title: titleCase(currentTab), to: `/settings/${currentTab}` }
        ]}
        style={{ marginBottom: '20px' }}
      />
      <General />
    </div>
  )
}
